<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-if="marker.archivedReports.length > 0" v-slot:activator="{ }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="dialog = true">
            <v-badge overlap v-if="marker.archivedReports.length > 0" color="primary">
              <template v-slot:badge>{{marker.archivedReports.length}}</template>
              <v-icon :color="marker.archivedReports.length > 0 ? '': ''">history</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>{{$t('archivedReports')}}</span>
      </v-tooltip>
    </template>
    <v-card tile class="bg-grey">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{$t('archivedReports')}}</v-toolbar-title>
      </v-toolbar>
      <v-container style="max-width: 960px" class="pa-2 mx-auto" fluid>
        <v-row>
          <v-col sm12 md6 cols="12" v-for="(report, i) in marker.archivedReports" :key="i">
            <v-card outlined>
              <!-- <v-card-title class="overline">
                {{marker.project}} > {{marker.buildingComponent}} > {{marker.blueprint}}
                <v-spacer></v-spacer>
              </v-card-title>-->
              <v-list-item three-line>
                <v-list-item-avatar tile size="125" color="grey">
                  <v-img :src="report.image"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <!-- <div
                    class="overline mb-4"
                  >{{marker.project}} > {{marker.buildingComponent}} > {{marker.blueprint}}</div>-->
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('name')}} & {{$t('company')}}:</b>
                    {{report.name}} {{report.company}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('email')}}/{{$t('phone')}}:</b>
                    {{report.email}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('date')}}:</b>
                    {{report.date}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('comment')}}:</b>
                    {{report.comment}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
                <v-select
                  style="width: 100%"
                  dense
                  outlined
                  readonly
                  v-if="report.markerXSolutionId"
                  v-model="report.markerXSolutionId"
                  :items="marker.markerXSolutions"
                  item-text="solution.name"
                  item-value="id"
                ></v-select>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";

export default {
  name: "Reports",
  props: {
    marker: Object
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    close() {
      this.dialog = false;
    }
  },
  created() {}
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Markers/archivedReports.vue